import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19 20a2.476 2.476 0 0 1-2.5-2.5 2.016 2.016 0 0 1 .3-1.1l-1.1-1.1a4.1 4.1 0 0 0-.7 2.2 4.012 4.012 0 0 0 4 4V23l2.2-2.2-2.2-2.3V20m0-6.5V12l-2.2 2.2 2.2 2.2V15a2.476 2.476 0 0 1 2.5 2.5 2.016 2.016 0 0 1-.3 1.1l1.1 1.1a4.1 4.1 0 0 0 .7-2.2 4.012 4.012 0 0 0-4-4z" }, null, -1),
    _createElementVNode("path", { d: "M13.522 21H1L12 2l5.335 9.215a6.475 6.475 0 0 0-1.854.819L12 6 4.5 19h8.176a6.434 6.434 0 0 0 .847 2z" }, null, -1),
    _createElementVNode("path", { d: "M14 14h-1.5l1.5-3h-4v4h1v3z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CheckAutomatic"}) } }